


export const photographicLinks = [
    {
        title: 'The Photographic Alliance of Great Britain',
        addresses: ['pagb-photography-uk.co.uk']
    },
    {
        title: 'The Surrey Photographic Association',
        addresses: ['surreypa.org.uk']
    },
    {
        title: 'The Royal Photographic Society',
        addresses: ['rps.org']
    },
    {
        title: 'British Institute of Professional Photographers',
        addresses: ['bipp.com']
    },
    {
        title: 'The Master Photographers Association',
        addresses: ['thempa.com']
    },
    {
        title: 'Photographic Society of America',
        addresses: ['psa-photo.org']
    }
];

export const tradeLinks = [
    {
        title: 'Adobe',
        addresses: ['adobe.com']
    },
    {
        title: 'Agfa',
        addresses: ['agfa.co.uk']
    },
    {
        title: 'Billingham',
        addresses: ['billingham.co.uk']
    },
    {
        title: 'Bronica',
        addresses: ['intro2020.co.uk']
    },
    {
        title: 'Canon',
        addresses: ['canon.co.uk']
    },
    {
        title: 'Carl Zeiss',
        addresses: ['zeiss.co.uk']
    },
    {
        title: 'CCS',
        addresses: ['ccscentre.co.uk']
    },
    {
        title: 'Colorama',
        addresses: ['colorama.photo.com']
    },
    {
        title: 'Cokin',
        addresses: ['intro2020.co.uk']
    },
    {
        title: 'Contax',
        addresses: ['kyu.co.uk']
    },
    {
        title: 'Epson',
        addresses: ['epson.co.uk']
    },
    {
        title: 'Fujifilm',
        addresses: ['fujifilm.co.uk']
    },
    {
        title: 'Gepe',
        addresses: ['gepe.com']
    },
    {
        title: 'Gitzo',
        addresses: ['gitzo.com']
    },
    {
        title: 'Hasselblad',
        addresses: ['hasselblad.com ']
    },
    {
        title: 'Hoya',
        addresses: ['hoyafilter.com']
    },
    {
        title: 'Kenro',
        addresses: ['kenro.co.uk']
    },
    {
        title: 'Kentmere',
        addresses: ['kentmere.co.uk']
    },
    {
        title: 'Kodak',
        addresses: ['kodak.co.uk']
    },
    {
        title: 'Leica',
        addresses: ['leica-camera.com']
    },
    {
        title: 'Lowepro',
        addresses: ['lowepro.com']
    },
    {
        title: 'Mamiya',
        addresses: ['mamiya.co.uk']
    },
    {
        title: 'Manfrotto',
        addresses: ['manfrotto.com']
    },
    {
        title: 'Metz',
        addresses: ['metzflash.co.uk']
    },
    {
        title: 'Nikon',
        addresses: ['nikon.co.uk']
    },
    {
        title: 'Nova Tanks',
        addresses: ['novadarkroom.com']
    },
    {
        title: 'Pentax',
        addresses: ['pentax.co.uk']
    },
    {
        title: 'Permejet',
        addresses: ['permajet.com']
    },
    {
        title: 'Sigma',
        addresses: ['sigma-imaging-uk.com']
    },
    {
        title: 'Tamron',
        addresses: ['intro2020.co.uk']
    },
    {
        title: 'Vivitar',
        addresses: ['vivitar.com']
    },
    {
        title: 'Voigtlander',
        addresses: ['voigtlaender.de']
    },
    {
        title: 'Yashica',
        addresses: ['kyu.co.uk']
    }
];

export const localLinks = [
    {
        title: 'Local Residents Association',
        addresses: ['moleseyresidentsassociation.org.uk']
    },
    {
        title: 'Hampton Court Palace',
        addresses: ['hrp.org.uk']
    },
    {
        title: 'The Barn Theatre',
        addresses: ['thebarntheatremolesey.co.uk']
    },
    {
        title: 'East Molesey Methodist Church',
        addresses: ['emmc.org.uk']
    }
];


// WEBPACK FOOTER //
// ./src/data/links.js